import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import { MyContext } from "../../Context/AuthContext";
import classes from "./NeedHand.module.css";
import { AiOutlineSearch } from "react-icons/ai";
import NeedHandChild from "./NeedHandChild";
// import { NeedHands } from "../../Track";
import AOS from "aos";
import "aos/dist/aos.css";
import BannerAbout from "./BannerAbout";
import { Box, Container } from "@mui/material";
import NewCommonity from "../Globalassets/NewCommonity";

const data = [
  {
    title: "Account Creation and management",
    questions: [
      {
        question: "1) Why can’t I find my country of residence when I try to open an account",
        answer: "If you can’t find your country of residence, unfortunately this means that we don’t currently service your country. Please check back in future though, as we are constantly expanding to new regions."
      },
      {
        question: "2) How do I start trading?",
        answer: "Before you can start trading, you need to:\n 1. Open your trading account\n 2. Verify your profile\n 3. Make a deposit\n 4. Download MT5 and start trading"
      },
      {
        question: "3) I am not receiving emails",
        answer: "Please check your spam or junk folder first. If you still can’t find the email, click on Resend verification on the portal login page or contact our support team for assistance."
      },
      {
        question: "4) Which documents do I need to provide to become a BBCorp client?",
        answer: "When opening a BBCorp account, we only ask that you provide a Proof of Identity (POI)\n This can be a color copy of any official documentation issued by a recognized authority. This includes passports (to be valid for at least 6 months), driver’s licenses, and identity cards. The document must include your full name, issue and expiry dates, your date and place of birth or tax identification number, and your signature\n Ready to get started? Click here to open your account, upload your documents, and start trading."
      },
      {
        question: "5) How do I verify my profile?",
        answer: "Verifying your account is a quick and simple process, just follow the steps below:\n .Log in to the Members Area,\n .Click the 'Verify Profile' button,\n .Complete the Profile, and Document Verification steps,\n .To track document verification status, you can check it in the header or go to 'Upload Documents' under the 'Profile' section. From there, you can see which documents you still need to upload to verify your account. With our automated verification systems, you should have the verification process completed in under 15 minutes."
      },
      {
        question: "6) Where can I find my account number and trading server?",
        answer: "To find your account number and trading server, please follow these steps:\n .Log in to the Dashboard Area\n .From the Home screen, click Accounts in the menu\n .Under the Overview of My Accounts section, click ‘Manage’ on each account card to reveal more information for that account, including your trading server"
      },
      {
        question: "7) I didn’t receive my verification email—what should I do?",
        answer: ""
      },
      {
        question: "8) How do I reset my account’s password?",
        answer: "To reset your password, just click here and follow the steps."
      }, {
        question: "9) Can I change my account type?",
        answer: "No, you can’t change your account type, but you can open an additional account of any type via the Accounts portal."
      },
      {
        question: "10)Can I change my leverage?",
        answer: "Yes. To change your leverage, just follow the steps below:\n .Login to the BBCorp Portal\n .Under the  Accounts section, click on the account you want to edit and change the leverage according to your desires."
      },
      {
        question: "11) Why do I need to verify my profile?",
        answer: "As a regulated company, we operate in accordance with a number of compliance-related issues and procedures imposed by our regulatory authority, the Capital Markets Authority(CMA). The CMA requires us to collect adequate information, including a valid Proof of Identity (POI), from all our clients as part of our Know Your Clients (KYC) procedure."
      },
      {
        question: "12) What type of accounts do you offer?",
        answer: "We offer a wide range of account types to meet the needs of all traders.For Real accounts, we offer Standard, Trader invest account types.For more information, check out our account types here"
      },
      {
        question: "13)  How do I use BBCorp’s Whatsapp trading portal?",
        answer: "To use BBCorp’s Whatsapp trading portal click on the whatsapp link and login or register your account through the portal."
      },
      {
        question: "14)Can I have a BBCorp web portal account and Whatsapp portal??",
        answer: "Yes you could use both at your convenience, you do not need to register a new account. All you have to do is sign in with your credentials"
      }
    ],

    desc1: "Why can’t I find my country..",
    desc2: "How do I start trading?",
    desc3: "I am not receiving emails",
  },
  {
    title: "Deposits & Withdrawals",
    path: "",
    // path: "/help3",
    questions: [
      {
        question: "1.What deposit methods are supported?",
        answer:
          "We support a variety of deposit methods including USDT (TRC20 and ERC20), local payment partners, bank transfers (in selected regions), and other digital payment channels. You can view the available options directly in your client portal.",
      },
      {
        question: "2.What’s the minimum deposit amount?",
        answer: "The minimum deposit is $10, depending on the account type and deposit method. Always check the specific requirement in your portal under the “Deposit” section.",
      },
      {
        question: "3.How long do deposits take to reflect in my account?",
        answer:
          "Crypto deposits (like USDT) are typically reflected within 10–30 minutes after network confirmation. Local and bank methods may take 1–3 business days depending on the provider and time of submission.",
      },
      {
        question: "4.How do I request a withdrawal?",
        answer:
          "Log in to your portal, go to the “Withdraw” section, choose your withdrawal method, enter the amount, and confirm. Your withdrawal request will be processed after verification and internal review.",
      },
      {
        question: "5.How long do withdrawals take?",
        answer:
          "rWithdrawals are generally processed within 24 hours. Crypto withdrawals are often completed in under 1 hour after approval, while local and bank methods may take 1–3 business days depending on your location and provider.",
      },
      {
        question: "6.What are the fees for deposits and withdrawals?",
        answer:
          "BB Corp does not charge fees for most deposits. Withdrawal fees vary depending on the method—crypto withdrawals typically incur network fees, and local/bank withdrawals may include service charges depending on the partner used. Full fee details are available inside the portal.",
      },
      {
        question: "7.Why is my withdrawal still pending?",
        answer:
          "Withdrawals may be pending due to:\n .Ongoing KYC or compliance checks\n .Insufficient balance or open positions in your trading account\n .Network congestion (for crypto)\n .Incorrect withdrawal information\n Please reach out to support if your withdrawal is pending for more than 24 hours.",
      },
      {
        question: "8.Can I withdraw using a different method from the one I used to deposit?",
        answer:
          "Bn the mbank withdrawals may include service charges depending on the partner used. Full fee details are available inside the portal.",
      },
    ],
    desc1: "What deposit methods are supported?",
    desc2: "What’s the minimum deposit amount?",
    desc3: "How long do deposits take to reflect..",
  },
  {
    title: "Trading",
    path: "",
    // path: "/help2",
    questions: [
      {
        question: "How do i add money to my BBCorp account?",
        answer:
          "As BBCorp continues to grow locally and internationally, you can add money to your BBCorp account via bank account or using a debit/credit card or through local cash providers in some areas",
      },
      {
        question: "Are there any fees fo adding money to my BBCorp account?",
        answer:
          "Adding money via bank transfer may have fees depending on your bank sender.We take a small fee on all bank transfer deposits. Adding money using a debit/credit card may incur a small processing fee. Details of any fees will be shown before you complete the transaction.",
      },
      {
        question:
          "Bow long does it take for the money to appear in my account?",
        answer:
          "Bank transfers typically take 1-3 business days to process.Adding money via debit/credit card is usually instant. As for cash deposits they are around 30 minutes to 1 hour (throughout office hours)",
      },
      {
        question: "What is the maximum amount i can add to my BBCorp account?",
        answer:
          "The maximum amount you can add depends on your account verification level. Please refer to the 'Limits' section in your app for specific details",
      },
    ],
    desc1: "Getting started with Revolut",
    desc2: "Revolut plans and benefits",
    desc3: "Submitting requested documents",
  },
  {
    title: "Trading Glossary",
    // path: "/help3",
    path: "",
    desc1: "Getting started with Revolut",
    desc2: "Revolut plans and benefits",
    desc3: "Submitting requested documents",
    questions: [
      {
        question: "**1. What is forex?**",
        answer:
          "Forex (foreign exchange) is the global marketplace for exchanging national currencies. It is the largest financial market in the world, operating 24/5.",
      },
      {
        question: "**2. How does forex trading work?**",
        answer:
          "Forex trading involves buying one currency while simultaneously selling another. Traders speculate on whether a currency will strengthen or weaken relative to another.œ",
      },
      {
        question:
          "**3. What are the bid and the ask?**",
        answer:
          "The bid is the highest price a buyer is willing to pay for a currency. The ask is the lowest price a seller is willing to accept. The difference is called the spread.",
      },
      {
        question: "**4. What is spread?**",
        answer:
          "Spread is the difference between the bid and the ask price. It represents the broker’s fee and liquidity in the market.",
      },
      {
        question: "**5. What are swaps?**",
        answer:
          "A swap is the interest paid or earned for holding a trading position overnight. It depends on the interest rate differential between the currencies traded.",
      },
      {
        question: "**6. What influences prices in forex trading?**",
        answer:
          "Currency prices are influenced by interest rates, inflation, economic data, political events, and market sentiment.",
      },
      {
        question: "**7. What is market execution?**",
        answer:
          "Market execution is when an order is executed immediately at the best available price in the market.",
      },
      {
        question: "**8. What is instant execution?**",
        answer:
          "Instant execution means an order is placed at a specific price and will only be executed at that exact price or rejected.",
      },
      {
        question: "**9. What are the differences between market and instant execution?**",
        answer:
          "Market execution allows for faster execution but not guaranteed price. Instant execution offers price certainty but risks rejection.",
      },
      {
        question: "**10. What does 'close by' mean?**",
        answer:
          "Close by is a method to close two opposite positions of the same symbol at the same time, saving the spread cost.",
      },
      {
        question: "**11. What does 'multiple close by' mean?**",
        answer:
          "This allows the closing of multiple hedged positions simultaneously, also saving spread costs.",
      },
      {
        question: "**12. What is Forex Trading Software?**",
        answer:
          "It's a platform (like MetaTrader) used for analyzing charts, executing trades, and managing trading accounts.",
      },
      {
        question: "**13. What are margin, margin level, and free margin?**",
        answer:
          "Margin is the collateral required to open a position. Margin level is the ratio of equity to used margin. Free margin is the amount available to open new positions.",
      },
      {
        question: "**14. What is market capitalisation?**",
        answer:
          "Market cap is the total value of a company’s shares. It's calculated by multiplying share price by total outstanding shares.",
      },
      {
        question: "**15. What are shares outstanding?**",
        answer:
          "Shares outstanding are the total number of a company’s shares held by all shareholders, including institutional investors and insiders.",
      },
      {
        question: "**16. What is a stop loss order?**",
        answer:
          "A stop loss automatically closes a trade at a specific price to limit losses.",
      },
      {
        question: "**17. What is a take profit order?**",
        answer:
          "A take profit closes a trade once a specified profit level is reached.",
      },
      {
        question: "**18. What is a trailing stop order?**",
        answer:
          "A trailing stop adjusts dynamically as the market moves in your favor, locking in profits while limiting downside.",
      },
      {
        question: "**19. What are Contracts for Difference (CFDs)?**",
        answer:
          "CFDs allow traders to speculate on price movements without owning the underlying asset.",
      },
      {
        question: "**20. What is a fractional Stock CFD?**",
        answer:
          "It enables trading in a portion of a full share, allowing investment with smaller amounts.",
      },
      {
        question: "**21. What is a futures contract?**",
        answer:
          "A futures contract is an agreement to buy or sell an asset at a future date at a predetermined price.",
      },
      {
        question: "**22. What are commodities?**",
        answer:
          "Commodities are physical goods like gold, oil, or wheat that can be traded on exchanges.",
      },
      {
        question: "**23. What are cryptocurrencies?**",
        answer:
          "Digital assets like Bitcoin and Ethereum that use cryptography and blockchain technology for secure, decentralized transactions.",
      },
      {
        question: "**24. What are Majors in Forex Trading?**",
        answer:
          "Major pairs include the most traded currencies like EUR/USD, USD/JPY, and GBP/USD.",
      },
      {
        question: "**25. What are Minors in Forex Trading?**",
        answer:
          "Minor pairs don’t include the USD but involve other strong currencies like EUR/GBP or EUR/JPY.",
      },
      {
        question: "**26. What are Exotics in Forex Trading?**",
        answer:
          "Exotics pair a major currency with a currency from a developing or smaller economy, such as USD/TRY.",
      },
      {
        question: "**27. What are Equity Indices (Stock Indices)?**",
        answer:
          "An index tracks the performance of a group of stocks, like the S\&P 500 or Dow Jones.",
      },
      {
        question: "**28. How Does Equity Indices Trading Work?**",
        answer:
          "Traders speculate on the movement of the index as a whole instead of individual stocks.",
      },
      {
        question: "**29. What is an acquisition?**",
        answer:
          "When one company purchases another, gaining control over its operations and assets.",
      },
      {
        question: "**30. What is a merger?**",
        answer:
          "A merger combines two companies into a single new entity.",
      },
      {
        question: "**31. What is a demerger?**",
        answer:
          "A demerger occurs when a company splits into separate independent businesses.",
      },
      {
        question: "**32. What is a reverse merger?**",
        answer:
          "A private company acquires a public one to bypass the lengthy IPO process.",
      },
      {
        question: "**33. What is an Initial Public Offering (IPO)?**",
        answer:
          "An IPO is when a company sells its shares to the public for the first time.",
      },
      {
        question: "**34. What is a rights issue?**",
        answer:
          "When a company offers more shares to existing shareholders at a discount to raise capital.",
      },
      {
        question: "**35. What is a stock split?**",
        answer:
          "A stock split increases the number of shares while reducing the price per share, maintaining total value.",
      },
      {
        question: "**36. What is a reverse stock split?**",
        answer:
          "A reverse split reduces the number of shares and increases the price per share to meet listing requirements.",
      },
      {
        question: "**37. What happens to a stock when it is delisted?**",
        answer:
          "It stops trading on a public exchange and may trade OTC. Investors may still hold or sell it.",
      },
      {
        question: "**38. What are Limit Downs and Limit Ups?**",
        answer:
          "These are price bands that prevent extreme movements in futures markets during high volatility.",
      },
      {
        question: "**39. What is slippage?**",
        answer:
          "Slippage is the difference between the expected price of a trade and the actual executed price, often during volatile markets.",
      },
      {
        question: "**40. What is a Fair Value Adjustment?**",
        answer:
          "A Fair Value Adjustment aligns open positions with market conditions, reflecting unrealized gains or losses.",
      },
      {
        question: "**41. What's the difference between spot and futures prices?**",
        answer:
          "Spot price is the current market price. Futures price is the agreed price for a transaction at a future date.",
      },
    ],
    desc1: "How do  transfer money to another BBCorp user?",
    desc2: "Can i transfer money to a non-BBCorp user?",
    desc3: "Are there any fees for transferring money?",
  },
  {
    title: "Technical Issues & Errors",
    path: "",
    // path: "/help3",
    path: "",
    desc1: "Getting started with Revolut",
    desc2: "Revolut plans and benefits",
    desc3: "Submitting requested documents",
    questions: [
      {
        question:
          "1.Why can’t I log into my trading account?",
        answer:
          "This could be due to:/n .Incorrect login credentials\n .Internet connectivity issues\n .Server maintenance or downtime\n .Account suspension or verification pending\n Check your credentials, try again later, or contact support if the issue persists.",

        // answer: "To order a BBCorp, go to the 'Cards' section in the app, select a virtual or physical card' and follow the instructions.Your card will be mailed to your registered address.",
      },
      {
        question:
          "2.What should I do if my platform is not loading?",
        answer:
          "Try the following:\n .Clear your browser/app cache\n .Ensure your internet connection is stable\n .Restart the platform or device\n .Check BB Corp’s status page or announcements for outages\n If the issue remains, contact support.",
      },
      {
        question:
          "3.Why is my trade not executing?",
        answer:
          "Trades may not execute due to:\n .Insufficient margin or free margin\n .Trading during non-market hours\n .Network lag or slippage during high volatility\n .Price movement exceeding slippage tolerance\n Double-check your margin and timing, or try again shortly.",
      },
      {
        question:
          "4.I see “off quotes” or “invalid price” – what does that mean?",
        answer:
          "These errors usually occur when:\n .The requested price is no longer available\n .There’s high market volatility or low liquidity\n .The internet connection is unstable\n Try re-entering the trade or refresh your platform.",
      },
      {
        question:
          "5.Why was my order rejected?",
        answer:
          "Orders may be rejected due to:\n .Invalid lot size or price\n .Attempting to trade an inactive or delisted instrument\n .Exceeding leverage limits\n .Placing an order during market closure\n Always verify order parameters before placing.",
      },
      {
        question:
          "6.Why does my chart look different from others?",
        answer:
          "Chart differences can arise from:\n .Timezone settings\n .Bid/ask charting mode\n .Data feed provider variations\n .Indicator settings\n Align settings or consult support to ensure consistency.",
      },
      {
        question:
          "7.My deposit is not showing – what should I do?",
        answer:
          ".For crypto: check blockchain confirmations and make sure the address is correct\n .For bank/local transfers: allow up to 2-3 business days\n .Ensure the payment reference was correctly included\n If the time window has passed, contact support with a screenshot or transaction ID.",
      },
      {
        question:
          "8.Why can’t I open a new position?",
        answer:
          "You may not be able to open a new position if:\n .You have insufficient free margin\n .There’s a platform limit on open trade\n .You are trading during a restricted session\n .Trading is disabled on the selected instrument\n Review your margin and instrument settings or contact support.",
      },
      {
        question:
          "9.Why am I getting disconnected frequently?",
        answer:
          "Frequent disconnections may be caused by:\n.Unstable internet connection\n .Running multiple terminals/platforms simultaneously\n .Platform overload or server congestion\n Restart your device or router and close unused sessions.",
      },
    ],
    // desc2: "Revolut plans and benefits",
    // desc3: "Submitting requested documents",
  },
  {
    title: "Partners & Brokers",
    path: "",
    // path: "/help3",
    desc1: "Getting started with Revolut",
    desc2: "Revolut plans and benefits",
    desc3: "Submitting requested documents",
    questions: [
      {
        question: "1.How can I become an Introducing Broker (IB) with BB Corp?",
        answer:
          "Visit our website or contact our partnership team to apply. You’ll need to complete a short form, provide your ID and business details, and agree to our IB terms. Once approved, you’ll receive your referral links and access to the IB dashboard.",
      },
      {
        question: "2.How does the IB commission structure work??",
        answer:
          "IBs earn a percentage of the spread or commission paid by referred clients. Our structure is tiered — the more volume your clients trade, the higher your rebate. Details can be viewed inside your partner dashboard.",
      },
      {
        question: " 3.When are commissions paid out?",
        answer:
          "Commissions are calculated daily and typically paid out weekly or monthly, depending on your agreement. You can track earnings in real-time through the IB portal.",
      },
      {
        question: "4.Can I refer both individual traders and companies??",
        answer:
          " Yes. You can refer any eligible trader — retail or institutional. If you’re targeting high-volume or corporate clients, we also offer tailored solutions and revenue-sharing terms.",
      },
      {
        question: "5.Is there a minimum number of clients I need to refer?",
        answer: "There is no strict minimum, but active IBs with consistent monthly referrals are prioritized for exclusive promotions, custom payouts, and marketing support.",
      },
      {
        question: "6.Can I track my clients’ activity?",
        answer:
          "Yes. The IB portal provides full visibility into your referred clients’ trading activity, commission generation, and account status — without disclosing personal data for compliance reasons..",
      },
      {
        question: "7.Do you offer marketing materials for partners?",
        answer:
          "Absolutely. We provide banners, PDFs, WhatsApp creatives, email templates, and landing pages in multiple languages. Custom creatives are also available for qualified partners.",
      },
      {
        question: "8.Is there a White Label or API partner program?",
        answer:
          "Yes. We offer both White Label solutions and API integration for financial institutions and fintech platforms. You can build your own front-end while using BB Corp’s backend liquidity and infrastructure.",
      },
      {
        question: "9.Can I integrate BB Corp’s services into my app or CRM?",
        answer:
          "Our API and Webhook system allows seamless integration of onboarding, deposits, trading, and reporting into third-party platforms. Contact us for technical documentation and sandbox access.",
      },
      {
        question: "10.What support do partners receive?",
        answer:
          "Every partner is assigned a dedicated relationship manager for daily support. We also provide access to our partner success team, technical engineers, and localized assistance when needed.",
      },
    ],

  },
  {
    title: "About Us",
    path: "",
    // path: "/help3",
    questions: [
      {
        question: "1.What is BB Corp?",
        answer:
          "BCorp is a modern, regulated brokerage firm focused on delivering fair, transparent, and accessible trading to both developed and underserved markets. We provide clients with tools to trade forex, commodities, indices, and crypto CFDs with confidence and speed.",
      },
      {
        question: "2. How old is BBCorp?",
        answer:
          "BB Corp was founded with humble beginnings in 1994, and obtained its first financial license in 2004, marking the start of our regulated journey in the financial industry.",
      },
      {
        question: "3.What is BB Corp’s mission?",
        answer:
          "Our mission is to democratize access to global financial markets by providing professional-grade tools, education, and infrastructure to all traders — especially in regions that are often overlooked or underserved.",
      },
      {
        question: "4.Where is BB Corp regulated or licensed?",
        answer:
          "BB Corp holds a brokerage license issued by the CMA and MISA, ensuring a compliant and secure trading environment. All client funds are held in segregated accounts under strict operational oversight.",
      },
      {
        question: "5.What makes BB Corp different from other brokers?",
        answer:
          "BB Corp is built with underserved traders in mind. We combine high-speed execution, low spreads, dedicated local support, and flexible deposit methods — all tailored for traders in emerging economies. We also offer real-time onboarding via WhatsApp and custom partnership models.",
      },
      {
        question:
          "6.Who are the founders or leadership behind BB Corp",
        answer:
          "BB Corp is led by a group of fintech experts, compliance professionals, and trading veterans with experience in global brokerage operations, technology scaling, and market access across MENA, Asia, and Africa.",
      },
      {
        question:
          "7.Which products and services does BB Corp offer?",
        answer:
          "We offer trading in:\n .Forex (majors, minors, exotics)\n .CFDs on Indices, Commodities, Crypto\n .Custom White Label & API solutions for partners\n .Multi-lingual onboarding and trading support",
      },
      {
        question:
          "8.Where does BB Corp operate?",
        answer:
          "While we serve clients globally, our primary focus is on high-growth and underserved markets across the Middle East, Africa, South Asia, and Latin America. We also support remote partners and digital brokers via our API.",
      },
      {
        question:
          "9.What platforms can I use to trade with BB Corp?",
        answer:
          "Clients can trade using web platforms, mobile apps, or MetaTrader platforms (MT5/MT4), depending on their preference. We also offer direct trading and onboarding via WhatsApp for select markets.",
      },
      {
        question:
          "10.Is BB Corp safe and secure to use?",
        answer:
          "Yes. We use strong data encryption, hold client funds in segregated accounts, and operate under strict regulatory oversight. Our compliance and risk management policies are aligned with global best practices.",
      },
      {
        question:
          "11.How can I get in touch with BB Corp?",
        answer:
          "You can contact us via:\n .Our website contact form\n .WhatsApp support portal\n .Dedicated partner managers\n .Email: support@bbcorp.trade\n We’re available to support you 24/5 in multiple languages.",
      },
    ],
    desc1: "Can i have multiple cards linked to my BBCorp account?",
    desc1: "Getting started with Revolut",
    desc2: "Revolut plans and benefits",
    desc3: "Submitting requested documents",
  },
  {
    title: "Tutorials",
    path: "",
    // path: "/help3",
    desc1: "Coming Soon",

  },

];

const Need = () => {

  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration
      once: false, // Animation triggers every time element appears
      mirror: true, // Re-animates when scrolling past
    });
  }, []);

  return (
    <>
      <div style={{ marginTop: "6rem" }}  >
        <BannerAbout />

      </div>
      <div style={{
        background: "#FFF",
      }}>
        <div className={classes.need_hand} >


          <div className={classes.need_hand_child} style={{ background: "transparent" }}>
            {data?.map((item, index) => (
              <NeedHandChild
                key={index}
                title={item.title}
                question={item?.questions}
                // description={item.description}
                desc1={item.desc1}
                desc2={item.desc2}
                desc3={item.desc3}
                path={"help-support"}
              />
            ))}
          </div>


        </div>
        <Container maxWidth="lg" sx={{ py: 4,  }}>


          <NewCommonity
            title={
              <>
                Need Help?
              </>
            }
            subtitle={
              <>
                If you have a question that isn't covered in the Help Centre, please contact<br /> us and one of our representatives will be happy to help you.
              </>
            }
          />
        </Container>

      </div>

    </>
  );
};

export default Need;